// Imports
import { createPinia } from 'pinia'
import i18n from '../../../vue/utils/i18n'
//@ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import CompatibilityTest from '../../../vue/components/pages/CompatibilityTest.vue'

// Vue
const pinia = createPinia()
const app = createApp({})

app.component('CompatibilityTest', CompatibilityTest)
app.use(pinia)
app.use(i18n)
app.mount('#app')
